import React from 'react';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import _ from 'lodash';

import Autosuggest from 'react-autosuggest';

import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class TransferenciaForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            data: moment(),
            descricao: '',
            valor: '',
            conta_origem_id: '',
            conta_destino_id: '',
            listaContas: [],
            suggestions: [],
            redirecionar: false,
            continuar: false,
        };
        this.debouncedLoadSuggestions = _.debounce(this.loadSuggestions, 1000);
    }

    componentDidMount = async () => {
        try { 
            const resContas = await axios.get(`${ambiente.dev.server}/contas`);
            this.setState({ listaContas : resContas.data });
            this.setState({ conta_origem_id: this.state.listaContas[0].id });
            this.setState({ conta_destino_id: this.state.listaContas[0].id });
            //Obtendo o id da transferência para o caso de um redirecionamento para alteração
            if(this.props.match.params.id) {
                const res = await axios.get(`${ambiente.dev.server}/transferencias/${this.props.match.params.id}`);
                let transferenciaBanco = res.data; 
                transferenciaBanco.data = moment(transferenciaBanco.data);
                this.setState({ ...transferenciaBanco });
            }
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.debouncedLoadSuggestions(value);
    };

    loadSuggestions = async ( value ) => {
        const inputValue = value.trim().toLowerCase();
        if(inputValue.length === 0) return [];
        const res = await axios.get(`${ambiente.dev.server}/transferencias/search?descricao=${inputValue}`);
        this.setState({ suggestions: res.data });
    };

    onSuggestionSelected = (evt, {suggestion}) => {
        this.setState({
            conta_origem_id: suggestion.conta_origem_id,
            conta_destino_id: suggestion.conta_destino_id,
        });
    }

    renderSuggestion = suggestion => {
        return (
            <div>
                {suggestion.descricao}
            </div>
        );
    }

    handleSave = async () => {
        const transfToSave = Object.assign({}, this.state);
        delete transfToSave.listaContas;
        delete transfToSave.suggestions;
        delete transfToSave.redirecionar;
        delete transfToSave.continuar;
        delete transfToSave.id;
        try {
            if(this.state.id) {
                await axios.put(`${ambiente.dev.server}/transferencias/${this.state.id}`, transfToSave);
                this.props.exibirMensagem('yay', `Transferência alterada com sucesso!`);
            } else {
                await axios.post(`${ambiente.dev.server}/transferencias`, transfToSave);
                this.props.exibirMensagem('yay', `Transferência inserida com sucesso!`);
            }
            if(!this.state.continuar) this.setState({ redirecionar: true });
          } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
          }
    }

    render() {
        if(this.state.redirecionar) return <Redirect to="/extrato" />;
        
        return (
            <div>
                <div className="row">
                    <div className="form-group col-8">
                        <Autosuggest theme={{input: "form-control"}}
                            suggestions={this.state.suggestions}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={() => this.setState({ suggestions: [] })}
                            getSuggestionValue={suggestion => suggestion.descricao}
                            renderSuggestion={this.renderSuggestion}
                            onSuggestionSelected={this.onSuggestionSelected}
                            inputProps={{
                                placeholder: 'Descrição...',
                                value: this.state.descricao,
                                onChange: (event, { newValue }) => this.setState({ descricao: newValue })
                            }}
                        />
                    </div>
                    <div className="form-group col-4">
                        <input type="number" step="0.01" placeholder="Valor" className="form-control" value={this.state.valor}
                            onChange={evt => this.setState({ valor: evt.target.value })}/>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col">
                        <input type="date" className="form-control" value={this.state.data.format('YYYY-MM-DD')} 
                            onChange={evt => this.setState({ data: moment(evt.target.value, 'YYYY-MM-DD')})}/>
                    </div>
                    <div className="form-group col">
                        <select className="form-control" value={this.state.conta_origem_id} onChange={evt => this.setState({ conta_origem_id: evt.target.value })}>
                            {this.state.listaContas.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col">
                        <select className="form-control" value={this.state.conta_destino_id} onChange={evt => this.setState({ conta_destino_id: evt.target.value })}>
                            {this.state.listaContas.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
                    Salvar
                </button>
            </div>
        );
    }
}

TransferenciaForm.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
  };
  
  function mapStateToProps(state) {
    return {};
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(TransferenciaForm);
  


// WEBPACK FOOTER //
// ./src/components/transferencia/TransferenciaForm.js